export default {
  nav: {
    home: 'Inicio',
    about: 'Acerca de Nosotros',
    products: 'Productos',
    materials: 'Nuevos Materiales de Carbono',
    solventfree: 'Adhesivo sin disolventes',
    estersolvent: 'Adhesivo con disolventes éster',
    alcoholicsolvent: 'Adhesivo con disolventes alcohólicos',
    news: 'Noticias',
    support: 'Soporte Técnico',
    hr: 'Recursos Humanos',
    contact: 'Contacto',
    more: 'Más',
    language: 'Idioma'
  },
  menu: {
    loading: 'Cargando...',
    home: 'Inicio',
    newCarbonMaterials: 'Nuevos Materiales de Carbono',
    adhesive: 'Adhesivo',
    technicalSupport: 'Soporte Técnico',
    newsCenter: 'Centro de Noticias',
    humanResource: 'Recursos Humanos',
    aboutUs: 'Acerca de Nosotros',
    contactUs: 'Contáctenos'
  },
  header:{
    menu: 'Menú',
    language: 'Idioma'
  },
  footer: {
    contactTitle: 'Siéntase libre de contactarnos:',
    contactTitleCn: 'Información de Contacto',
    addressTitle: 'DIRECCIÓN:',
    addressTitleCn: 'Dirección',
    address: 'No.688 Xifeng Road, Nantaihu New Area, Huzhou City, Zhejiang Province, China',
    addressCn: 'No.688 Xifeng Road, Área Nueva Nantaihu, Ciudad Huzhou, Provincia Zhejiang, China'
  },
  languageDialog: {
    title: 'Elige tu idioma',
    current: 'Actual',
    switchSuccess: 'Idioma cambiado con éxito',
    description: 'Nos comprometemos a brindar soporte multiidioma para usuarios globales, permitiendo que más personas usen nuestros servicios de manera conveniente.',
    contactNote: 'Si necesita soporte en otros idiomas, póngase en contacto con nuestro equipo de atención al cliente.'
  },
  home: {
    title: 'Inicio',
    banner: {
      title: 'Visión Global, Servicio Local',
      subtitle: 'Equipo internacional que brinda servicios profesionales localizados',
      heroTitle: 'Innovación para equilibrar las necesidades humanas de energía y medio ambiente',
      heroSubtitle: 'Integridad, Excelencia, Innovación - Impulsando la industria hacia el desarrollo verde y ecológico',
      learnMore: 'Aprender Más'
    },
    about: {
      title: 'Perfil de la Empresa',
      content: 'Somos una empresa enfocada en la innovación y la calidad, comprometida a brindar a los clientes los mejores productos y servicios. Desde nuestro establecimiento, hemos perseguido continuamente la excelencia, centrándonos en las necesidades del cliente y mejorando continuamente nuestros productos y servicios.',
      companyIntro: 'Huzhou OChem Chemical Co., Ltd. es una de las subsidiarias de Carbon Material LLC con sede en Houston, Texas, EE.UU., que invierte en China. La empresa está ubicada en la conveniente ciudad del Delta del Río Yangtze - Huzhou, cerca del Aeropuerto Internacional de Hangzhou, el Aeropuerto Internacional Lukou de Nanjing y el Aeropuerto Internacional Pudong de Shanghai, con transporte muy conveniente.',
      companyPhilosophy: 'La empresa sigue la filosofía empresarial de "Integridad, Excelencia, Innovación", con la visión de equilibrar las necesidades humanas de energía y medio ambiente a través de la innovación, promoviendo continuamente la industria hacia una dirección verde y ecológica a través de investigación y desarrollo profundo y productos y tecnologías de aplicación continuamente innovadores.',
      viewMore: 'Ver Más',
      viewDetails: 'Ver Detalles'
    },
    meta: {
      description: 'Huzhou OChem Chemical Co., Ltd. - Fabricante profesional de productos químicos, comprometido con innovar para equilibrar las necesidades humanas de energía y medio ambiente'
    },
    products: {
      title: 'Nuestros Productos',
      product1: {
        name: 'Adhesivo Libre de Solvente',
        description: 'Adhesivo compuesto ecológico sin solvente apto para embalaje de alimentos y otras aplicaciones'
      },
      product2: {
        name: 'Adhesivo de Éster Solvente',
        description: 'Adhesivo compuesto de éster solvente de alto rendimiento con excelente resistencia de unión'
      },
      product3: {
        name: 'Adhesivo de Ingeniería Estructural',
        description: 'Adhesivo profesional de ingeniería estructural ampliamente utilizado en campos de construcción e industrial'
      }
    },
    advantages: {
      title: 'Nuestras Ventajas',
      innovation: {
        title: 'Innovación Técnica',
        description: 'Continua inversión en I+D, lanzando constantemente productos y soluciones innovadores'
      },
      quality: {
        title: 'Garantía de Calidad',
        description: 'Estricto sistema de gestión de calidad garantizando alta calidad y confiabilidad de productos'
      },
      environment: {
        title: 'Concepto Ambiental',
        description: 'Comprometido con la protección ambiental verde, desarrollando productos químicos sostenibles'
      },
      service: {
        title: 'Servicio Profesional',
        description: 'Equipo técnico profesional proporcionando soporte técnico integral para clientes'
      }
    }
  },
  about: {
    title: 'Acerca de Nosotros',
    subtitle: 'Conoce nuestra historia, misión y valores',
    introHeader: 'Introducción de la Empresa',
    introTitle: 'Innovación para equilibrar las necesidades humanas de energía y el medio ambiente',
    companyIntro: 'Nuestra empresa fue fundada en 2005, es una empresa que se enfoca en la investigación y desarrollo y producción de productos de alta tecnología. Después de años de desarrollo, nos hemos convertido en una empresa líder en la industria, con productos exportados a muchos países y regiones alrededor del mundo.',
    vr: {
      panoramicVR: 'VR Panorámico',
      visitUs: 'No es necesario estar presente. Solo visítanos',
      slideMouse: 'Desliza el ratón para continuar tu visita'
    },
    meta: {
      description: 'Conoce la historia, misión y valores de Huzhou OChem Chemical Co., Ltd., estamos comprometidos con la investigación y desarrollo innovador de productos químicos'
    },
    teamIntro: 'Tenemos un equipo de I+D de alta calidad, continuamente lanzando productos innovadores para satisfacer las demandas del mercado. Nuestra base de producción está equipada con equipos de producción avanzados y un sistema completo de gestión de calidad, asegurando la alta calidad y confiabilidad de los productos.',
    philosophy: 'Nos adherimos a la filosofía empresarial de "Innovación, Calidad, Integridad, Ganar-Ganar", comprometidos a brindar a los clientes los productos y servicios de la más alta calidad, desarrollándonos junto con socios para lograr beneficios mutuos.',
    culture: {
      title: 'Cultura Empresarial',
      innovation: {
        title: 'Innovación',
        description: 'Nos comprometemos con la innovación tecnológica y el desarrollo de productos, lanzando continuamente nuevos productos que satisfagan las demandas del mercado'
      },
      quality: {
        title: 'Calidad',
        description: 'Estricto sistema de gestión de calidad asegurando que cada producto cumpla con los más altos estándares'
      },
      integrity: {
        title: 'Integridad',
        description: 'Tratar a las personas con honestidad y establecer negocios con confianza, construyendo asociaciones duraderas y estables'
      },
      philosophy: {
        title: 'Filosofía',
        description: 'Innovación para equilibrar las necesidades humanas de energía y medio ambiente, promoviendo desarrollo industrial sostenible'
      }
    },
    timeline: {
      title: 'Historial de Desarrollo',
      item1: {
        title: 'Establecimiento de la Empresa',
        description: 'La empresa invirtió $4 millones para establecer "Huzhou OChem Chemical Co., Ltd." en Huzhou'
      },
      item2: {
        title: 'Inicio de Producción',
        description: 'La empresa se completó y puso en producción en mayo de 2005'
      },
      item3: {
        title: 'Desarrollo de Nuevos Productos',
        description: 'Desarrolló nuevos químicos finos de tratamiento de agua funcional e innovó continuamente para desarrollar productos de tratamiento de agua ecológicos y de alta eficiencia'
      },
      item4: {
        title: 'Expansión de Productos',
        description: 'Para adaptarse a la demanda del mercado, la empresa desarrolló productos de adhesivo de poliuretano sin solvente'
      },
      item5: {
        title: 'Actualización Industrial',
        description: 'Siguiendo la tendencia de los tiempos, la empresa ingresó a las industrias de nuevas energías y nuevos materiales, expandiendo su modelo y alcance de negocios, utilizando sus ventajas de empresa química para promover rápidamente el desarrollo de nuevos materiales de carbono'
      },
      item6: {
        title: 'Recuperación de Solvente',
        description: 'La empresa se expandió a nuevos campos de recuperación de solventes, construyó línea de producción de purificación de solvente NMP para reciclaje de solvente NMP'
      },
      item7: {
        title: 'Logros de Patentes',
        description: 'Hasta este año, la empresa ha obtenido 11 patentes de invención autorizadas (incluyendo una patente estadounidense y una patente europea)'
      },
      item8: {
        title: 'Expansión de Capacidad',
        description: 'La capacidad de producto de adhesivo sin solvente aumentó de la capacidad anual original de 3,000 toneladas a 6,000 toneladas'
      },
      item9: {
        title: 'Reconocimiento del Mercado',
        description: 'Los productos de adhesivo sin solvente de un componente desarrollados recientemente ganaron amplio reconocimiento del mercado por rendimiento y estabilidad de calidad, ocupando una cuota de mercado en crecimiento estable'
      },
      item10: {
        title: 'Diversificación de Productos',
        description: 'Los productos recientemente desarrollados de la empresa incluyendo imprimador a base de agua PVDC, adhesivo de película blíster de embalaje farmacéutico, adhesivo resistente al estiramiento y cocción, adhesivo de recubrimiento de aleación de aluminio y pintura de madera están ganando gradualmente reconocimiento del mercado'
      },
      item11: {
        title: 'Construcción del Centro de I+D',
        description: 'El nuevo centro de I+D de la empresa iniciará construcción, invitando talentos a unirse con anticipación'
      }
    }
  },
  products: {
    title: 'Productos',
    meta: {
      description: 'Introducción de Productos de Huzhou OChem Chemical Co., Ltd. - Adhesivos compuestos de empaque suave, adhesivos de ingeniería estructural y otros productos químicos profesionales'
    },
    viewDetails: 'Ver Detalles',
    cancel: 'Cancelar',
    jumpToDetails: 'Ir a página detallada',
    categories: {
      solventFree: {
        title: 'Serie de Adhesivo Libre de Solvente',
        description: 'Adhesivo compuesto libre de solvente de alto rendimiento apto para varios materiales de empaque'
      },
      esterSolvent: {
        title: 'Serie de Adhesivo de Éster Solvente',
        description: 'Adhesivo compuesto de éster solvente profesional con excelente rendimiento de unión'
      }
    },
    solventFree: {
      product1: {
        application: 'Aplicación Amplia',
        infoLabel1: 'T.F EN ANSI 31-2024',
        infoValue1: 'DECAIMIENTO RÁPIDO PAA',
        descriptions: [
          'Isocianato mixto aromático y alifático',
          'Cura resistente AL RCPP 13°C',
          'PAA en PootiStaff >0.01 mg/kg después de curado'
        ]
      }
    }
  },
  materials: {
    title: 'Nuevos Materiales de Carbono',
    learnMore: 'Aprender Más',
    information: 'información',
    detailModal: {
      description: 'Descripción del Producto',
      specifications: 'Especificaciones',
      applications: 'Aplicaciones',
      features: 'Características Clave',
      close: 'Cerrar',
      contact: 'Contáctanos'
    },
    material1: {
      category: 'Materiales de Carbono',
      title: 'Nuevo',
      description: 'El carbono es uno de los elementos más relacionados e importantes que existen en la naturaleza. Al mismo tiempo, debido a su microestructura especial, el material de carbono compuesto por sesenta elementos tiene propiedades únicas, y la fase de nanocarbono, y ahora los materiales de carbono se están desarrollando constantemente y fabricando artificialmente.'
    },
    material2: {
      title: 'Nanotubos de Carbono',
      description: 'El nanotubo de carbono es un tipo de nanomaterial que se forma. Sus características estructurales de forma extremadamente ordenada. Agregarlo al concreto no puede ser la batería para una conductividad efectiva para mantener un rendimiento de capacidad térmica específica suficiente. Como dirección conductiva y batería de iones de litio primera y conductividad líquida.',
      placeholder: 'Estructura de Nanotubos de Carbono'
    },
    material3: {
      title: 'Suspensión Conductiva',
      description: 'Punto de mezcla de transmisión de carbono en forma de aglomeración con varias suspensiones cristalinas durante el proceso de producción e iones de litio y su componente de sulfuro de carbono. Como uno de los nanotubos de carbono en un sistema de solvente líquido, con un contenido generalmente entre 2-10% y una viscosidad moderada, lo que brinda gran conveniencia a las aplicaciones posteriores.',
      placeholder: 'Suspensión Conductiva'
    },
    material4: {
      title: 'Nanofibra de Carbono',
      description: 'La nanofibra de carbono es un tipo de nanofibra que crece continuamente por el método de deposición de vapor, con un diámetro de 120-200 nanómetros. Tiene las características de alta conductividad, alta conductividad, alta resistencia, buena flexibilidad y fácil dispersión. Es indispensable para muchas aplicaciones conductivas.',
      placeholder: 'Nanofibra de Carbono'
    },
    material5: {
      title: 'Material de Grafito Poroso Compuesto',
      description: 'El carbono blando poroso es un material de carbono sintético con alta superficie específica, tamaño de poro y volumen de poro, así como una cierta estructura de grafito, por lo que es un material especial de ánodo de batería de litio con carga rápida y rendimiento a largo plazo. A través de fórmula especial y tecnología de procesamiento, el material tiene alta capacidad (>350 mah/g) y eficiencia satisfactoria de primera carga y descarga.',
      placeholder: 'Grafito Poroso Compuesto'
    },
    material6: {
      title: 'Nuevo Producto en Desarrollo',
      description: 'Con el desarrollo de la tecnología científica y la mejora de los estándares de vida de las personas, los nuevos materiales de carbono se han desarrollado rápidamente, y se espera que se produzcan cada vez más productos de materiales de carbono.',
      placeholder: 'Equipo de Investigación'
    }
  },
  news: {
    title: 'Centro de Noticias',
    newsCenter: 'Noticias Corporativas',
    subtitle: 'Conoce las últimas dinámicas de la empresa y noticias de la industria',
    viewAll: 'Ver Todas las Noticias',
    developing: 'Función de mostrar todas las noticias en desarrollo',
    releaseTime: 'Tiempo de Lanzamiento',
    learnMore: 'Aprender Más',
    emptyHint: 'Aún no hay noticias publicadas. Vuelve a intentarlo pronto.',

    news1: {
      title: 'Avance en Tecnología de Nuevos Materiales',
      summary: 'Hemos logrado grandes avances tecnológicos en materiales de carbono, nuevos productos traerán mejores soluciones para clientes...'
    },
    news2: {
      title: 'Producción Ambiental Verde',
      summary: 'La empresa está comprometida con la producción ambiental, adoptando la última tecnología limpia para contribuir al desarrollo sostenible...'
    },
    news3: {
      title: 'Proyecto de Cooperación Internacional',
      summary: 'Se llegó a cooperación estratégica con empresas internacionalmente reconocidas para promover conjuntamente I+D y aplicación de materiales de nueva energía...'
    },
    news4: {
      title: 'Expansión del Equipo de I+D',
      summary: 'El equipo de I+D de la empresa continúa expandiéndose, atrayendo más expertos de la industria para unirse a nuestro equipo...'
    },
    news5: {
      title: 'Certificación de Calidad de Productos',
      summary: 'Nuestros productos han pasado múltiples certificaciones de calidad internacionales, proporcionando garantía más confiable para clientes...'
    },
    news6: {
      title: 'Premio de Innovación Tecnológica',
      summary: 'La empresa ganó premio de innovación tecnológica de la industria, demostrando nuestros logros destacados en I+D de tecnología...'
    },
    news7: {
      title: 'Plan de Expansión de Mercado',
      summary: 'Se formuló un nuevo plan de expansión de mercado para ampliar aún más nuestra influencia en el mercado...'
    },
    news8: {
      title: 'Certificación Ambiental Obtenida',
      summary: 'La empresa obtuvo múltiples certificaciones ambientales, reflejando nuestro compromiso con el desarrollo sostenible...'
    },
    news9: {
      title: 'Transformación Digital',
      summary: 'Promoviendo integralmente la transformación digital para mejorar la eficiencia de producción y el nivel de gestión...'
    },
    news10: {
      title: 'Actualización de Manufactura Inteligente',
      summary: 'Introduciendo las últimas tecnologías de manufactura inteligente para lograr automatización e inteligencia de procesos de producción...'
    },
    news11: {
      title: 'Estrategia de Desarrollo Sostenible',
      summary: 'Formulando e implementando estrategias de desarrollo sostenible, cumpliendo responsabilidades sociales mientras se aseguran beneficios económicos...'
    },
    news12: {
      title: 'Programa de Desarrollo de Talento',
      summary: 'Lanzando programa integral de desarrollo de talento para proporcionar a empleados más oportunidades de avance profesional y mejora de habilidades...'
    },
    prevPage: 'Anterior',
    nextPage: 'Siguiente',
    viewingNews: 'Viendo Noticias'
  },
  support: {
    title: 'Soporte Técnico',
    download: 'Descargar',
    downloading: 'Descargando',
    document: 'documento',
    downloadReady: 'está listo. En el entorno de producción, esto activará una descarga real.',
    downloadError: 'Archivo temporalmente no disponible, por favor inténtelo más tarde',
    documents: {
      doc1: {
        type: 'Hoja de Datos Técnicos',
        title: 'Hoja de Datos Técnicos SF9310A-SF9310B'
      },
      doc2: {
        type: 'Hoja de Datos Técnicos',
        title: 'Hoja de Datos Técnicos SF9620A-SF9620B'
      },
      doc3: {
        type: 'Hoja de Datos Técnicos',
        title: 'Hoja de Datos Técnicos SF9270A-SF9270B'
      },
      doc4: {
        type: 'Especificación de Producto',
        title: 'Especificación de Producto Nanotubo de Carbono'
      },
      doc5: {
        type: 'Guía de Usuario',
        title: 'Guía de Usuario de Suspensión Conductiva'
      },
      doc6: {
        type: 'Guía de Aplicación',
        title: 'Guía de Aplicación de Alta Temperatura'
      },
      doc7: {
        type: 'Hoja de Datos de Seguridad',
        title: 'Hoja de Datos de Seguridad de Material'
      },
      doc8: {
        type: 'Catálogo de Productos',
        title: 'Catálogo de Productos 2024'
      },
      doc9: {
        type: 'Manual de Instalación',
        title: 'Manual de Instalación de Producto'
      },
      doc10: {
        type: 'Certificación',
        title: 'Certificación ISO'
      }
    }
  },
  hr: {
    title: 'Recursos Humanos',
    subtitle: 'Únete a nuestro equipo - Creando el futuro juntos',
    description: 'Nos comprometemos a brindar a talento excelente amplias plataformas de desarrollo y paquetes de compensación competitivos, esperamos trabajar contigo para crear un futuro mejor',
    joinUs: 'Por favor envíe su currículum a {email},  Tel: {phone}. Nuestro departamento de RR.HH. se pondrá en contacto con usted lo antes posible.',
    currentOpenings: 'Vacantes Actuales',
    fields: {
      address: 'Dirección',
      branch: 'Departamento',
      workingYears: 'Años de Trabajo',
      education: 'Educación',
      hiring: 'Contratación',
      releaseDate: 'Fecha de Publicación'
    },
    whyJoinUs: 'Por Qué Unirse a Nosotros',
    keyRequirements: 'Requisitos Clave',
    applyNow: 'Aplicar Ahora',
    thankYou: 'Gracias por solicitar',
    position: 'posición',
    sendResume: 'Procesaremos su solicitud lo antes posible',
    expand: 'Mostrar más',
    collapse: 'Ocultar',
    fullRequirements: 'Requisitos Completos del Trabajo',
    responsibilities: 'Responsabilidades del Trabajo',
    benefits: 'Beneficios',
    contactInfo: 'Información de Contacto',
    contactEmail: 'Correo Electrónico',
    contactPhone: 'Teléfono',
    noPositions: 'Sin vacantes disponibles',
    jobs: {
      seniorEngineer: {
        title: 'Ingeniero de Materiales Senior',
        type: 'Tiempo Completo',
        location: 'Huzhou, China',
        experience: '3-5 Años',
        education: 'Maestría',
        salary: '¥20K-35K',
        description: 'Únete a nuestro equipo de I+D para desarrollar materiales de carbono de próxima generación y soluciones innovadoras para aplicaciones de almacenamiento de energía.',
        requirements: [
          'Maestría en Ciencia de Materiales, Ingeniería Química o campo relacionado',
          '3+ años de experiencia en I+D de materiales de carbono o materiales compuestos',
          'Competencia en técnicas de caracterización de materiales',
          'Fuertes habilidades analíticas y de resolución de problemas',
          'Excelentes habilidades de comunicación en inglés y chino'
        ],
        responsibilities: [
          'Liderar desarrollo y mejora de productos de materiales de carbono',
          'Diseñar y ejecutar planes experimentales, analizar resultados',
          'Colaborar con equipos multifuncionales para avanzar proyectos',
          'Preparar reportes técnicos y solicitudes de patentes',
          'Participar en intercambios técnicos con clientes y promoción de productos'
        ],
        benefits: [
          'Salario competitivo y paquete de compensación',
          'Seguro social integral y seguro médico comercial',
          'Chequeo de salud anual',
          'Oportunidades de capacitación profesional y desarrollo de carrera',
          'Horario flexible y ambiente de oficina cómodo'
        ]
      },
      rdScientist: {
        title: 'Científico de Investigación y Desarrollo',
        type: 'Tiempo Completo',
        location: 'Shanghai, China',
        experience: '2-4 Años',
        education: 'Licenciatura',
        salary: '¥15K-25K',
        description: 'Contribuir a proyectos de investigación innovadores enfocados en nanomateriales de carbono avanzados y sus aplicaciones industriales.',
        requirements: [
          'Licenciatura en Química, Ciencia de Materiales o campo relacionado',
          '2+ años de experiencia en investigación de nanomateriales',
          'Experiencia con síntesis y caracterización de materiales de carbono',
          'Fuertes habilidades de laboratorio y atención al detalle',
          'Capacidad para trabajar independientemente y en entornos de equipo'
        ],
        responsibilities: [
          'Conducir síntesis y caracterización de nanomateriales de carbono',
          'Optimizar parámetros del proceso de preparación de material',
          'Realizar pruebas de rendimiento de productos y análisis de datos',
          'Asistir en desarrollo de planes de proyectos de I+D',
          'Colaborar con equipos de industrialización para avanzar transferencia tecnológica'
        ],
        benefits: [
          'Salario base competitivo',
          'Sistema integral de seguro social',
          'Bonificaciones de proyectos y recompensas anuales',
          'Oportunidades de intercambio académico y capacitación',
          'Excelente ambiente de I+D y equipos'
        ]
      },
      processEngineer: {
        title: 'Ingeniero de Procesos',
        type: 'Tiempo Completo',
        location: 'Huzhou, China',
        experience: '1-3 Años',
        education: 'Licenciatura',
        salary: '¥12K-20K',
        description: 'Optimizar procesos de producción para asegurar la calidad y eficiencia de productos de materiales de carbono.',
        requirements: [
          'Licenciatura en Ingeniería Química o campo relacionado',
          '1+ años de experiencia en producción química',
          'Conocimiento de protocolos de control de calidad y seguridad',
          'Fuertes habilidades analíticas y de resolución de problemas',
          'Buen espíritu de trabajo en equipo'
        ],
        responsibilities: [
          'Supervisar y optimizar procesos de producción de materiales de carbono',
          'Conducir ajustes de parámetros de proceso y mantenimiento de equipos',
          'Ejecutar procedimientos de control de calidad para asegurar especificaciones de productos',
          'Analizar datos de producción y proponer mejoras',
          'Participar en desarrollo y validación de nuevos procesos'
        ],
        benefits: [
          'Ingresos de salario estable',
          'Cinco seguros sociales completos y fondo de vivienda',
          'Oportunidades de capacitación para mejora de habilidades',
          'Garantía de estabilidad laboral',
          'Buen ambiente de trabajo y atmósfera de equipo'
        ]
      }
    },
    culture: {
      innovation: {
        title: 'Impulsado por la Innovación',
        description: 'Fomentamos el pensamiento innovador e invertimos en I+D de vanguardia, permitiendo que tu creatividad florezca aquí.'
      },
      growth: {
        title: 'Desarrollo Profesional',
        description: 'Sistema de capacitación integral y vías de promoción para apoyar tu crecimiento profesional y desarrollo personal.'
      },
      teamwork: {
        title: 'Trabajo en Equipo',
        description: 'Equipo internacional diverso con un ambiente de trabajo abierto e inclusivo, persiguiendo la excelencia juntos.'
      },
      benefits: {
        title: 'Beneficios y Compensación',
        description: 'Salario competitivo, beneficios sociales integrales, chequeos de salud anuales, actividades de construcción de equipo y más.'
      }
    }
  },
  contact: {
    title: 'Contáctenos',
    titleCard: 'Por favor contáctenos',
    subtitle: 'Puede encontrar nuestra información de contacto aquí',
    contactInfo: 'Contacto',
    Tel: 'Tel',
    overseasOffice: 'Oficina en el Extranjero',
    usOffice: 'Oficina Principal en EE.UU.',
    usAddress: 'Houston, Texas, EE.UU.',
    usAddressFull: '12603 Southwest Freeway, Suite 210 Stafford, Texas 77477 EE.UU.',
    mapLoadError: 'Error al cargar el mapa, por favor inténtelo más tarde',
    mapAlt: 'Mapa de Ubicación de la Empresa - No.688 Xifeng Road, Área Nueva Nantaihu, Ciudad Huzhou, Provincia Zhejiang, China',
    companyName: 'Huzhou OChem Chemical',
    phoneConsultation: 'Consulta Telefónica',
    phoneHours: 'Lunes a Viernes 9:00-18:00',
    email: 'Correo Electrónico',
    emailNote: 'Respuesta en 24 horas',
    address: 'Dirección',
    addressNote: 'Área Nueva Nantaihu, Ciudad Huzhou, Provincia Zhejiang, China',
    onlineSupport: 'Soporte en Línea',
    onlineSupportNote: 'Haga clic para chatear',
    supportHours: 'Días laborables 9:00-22:00',
    messageConsultation: 'Consulta de Mensaje',
    nameLabel: '* Nombre',
    namePlaceholder: 'Por favor ingrese su nombre',
    phoneLabel: 'Teléfono',
    phonePlaceholder: 'Por favor ingrese su teléfono',
    emailLabel: 'Correo',
    emailPlaceholder: 'Por favor ingrese su correo',
    companyLabel: 'Empresa',
    companyPlaceholder: 'Por favor ingrese su empresa',
    messageLabel: 'Contenido del Mensaje',
    messagePlaceholder: 'Por favor ingrese el contenido de su mensaje',
    submit: 'Enviar',
    reset: 'Restablecer',
    companyLocation: 'Ubicación de la Empresa',
    companyFullName: 'Huzhou OChem Chemical Co., Ltd',
    postalCode: 'Código Postal',
    loadingMap: 'Cargando mapa...',
    mapNote: 'En el proyecto real se puede integrar la API de Baidu Maps o Gaode Maps',
    nameRequired: 'Por favor ingrese el nombre',
    emailInvalid: 'Por favor ingrese una dirección de correo válida',
    submitSuccess: 'Su mensaje ha sido enviado con éxito, nos pondremos en contacto con usted pronto',
    calling: 'Marcando 0572-2678666 para usted',
    openingEmail: 'Abriendo cliente de correo para usted',
    onlineServiceDeveloping: 'Función de servicio al cliente en línea en desarrollo, por favor contáctenos por teléfono o correo',
    emailSubject: 'Consulta',
    emailBody: 'Hola, me gustaría conocer más información.'
  },
  language: {
    title: 'Selección de Idioma',
    subtitle: 'Seleccione su idioma preferido',
    description: 'Nos comprometemos a brindar soporte multiidioma para usuarios globales, permitiendo que más personas usen nuestros servicios de manera conveniente.',
    contactNote: 'Si necesita soporte en otros idiomas, póngase en contacto con nuestro equipo de atención al cliente.',
    current: 'Selección Actual',
    switchSuccess: 'El idioma se ha cambiado a:',
    chineseSimplified: 'Chino Simplificado',
    chineseTraditional: 'Chino Tradicional',
    english: 'Inglés',
    spanish: 'Español',
    chineseSimplifiedDesc: 'Chino estándar utilizado en China continental',
    chineseTraditionalDesc: 'Chino tradicional utilizado en la región de Taiwán',
    englishDesc: 'Inglés americano estándar',
    spanishDesc: 'Español estándar'
  },
  shareModal: {
    title: 'Compartir Página',
    selectPlatform: 'Seleccionar Plataforma',
    copyLink: 'Copiar Enlace',
    copy: 'Copiar',
    copySuccess: '¡Enlace copiado exitosamente!',
    wechatTip: 'La función de compartir en WeChat está en desarrollo, puede copiar el enlace y compartir manualmente',
    shareToFacebook: 'Compartir en Facebook',
    shareToLinkedIn: 'Compartir en LinkedIn'
  },
  languageWelcome: {
    title: 'Mucho gusto, por favor elige tu idioma',
    subtitle: 'Ofrecemos soporte multiidioma, selecciona tu idioma preferido',
    note: 'Puedes cambiar tu preferencia de idioma en cualquier momento en configuración',
    switchSuccess: 'Idioma cambiado a:'
  },
  newsDetailModal: {
    title: 'Detalles de Noticias',
    publishTime: 'Tiempo de Publicación',
    close: 'Cerrar',
    loadError: 'Error al cargar los detalles de la noticia, por favor intente más tarde'
  },
  menuCarousel: {
    home: {
      title: 'Inicio',
      subtitle: 'Bienvenido a Huzhou OChem Chemical',
      description: 'Fabricante profesional de productos químicos, comprometido a brindar a clientes productos y servicios de calidad',
      viewMore: 'Aprender Más'
    },
    about: {
      title: 'Acerca de Nosotros',
      subtitle: 'Innovación para equilibrar las necesidades humanas de energía y medio ambiente',
      description: 'Huzhou OChem Chemical Co., Ltd., enfocada en I+D y producción de productos de alta tecnología, convirtiéndose en empresa líder en la industria',
      viewMore: 'Ver Detalles'
    },
    solventFreeProducts: {
      title: 'ADHESIVO LIBRE DE SOLVENTE',
      subtitle: 'Adhesivo Compuesto Ecológico Sin Solvente',
      description: 'Adhesivo compuesto sin solvente de alto rendimiento apto para embalaje de alimentos y otras aplicaciones, con características de protección ambiental, seguridad y eficiencia',
      viewMore: 'Ver Productos'
    },
    esterSolventProducts: {
      title: 'ADHESIVO DE ÉSTER SOLVENTE',
      subtitle: 'Adhesivo Compuesto de Éster Solvente de Alto Rendimiento',
      description: 'Adhesivo compuesto de éster solvente profesional con excelente rendimiento de unión, ampliamente utilizado en varios materiales de empaque',
      viewMore: 'Ver Productos'
    },
    alcoholicSolventProducts: {
      title: 'ADHESIVO DE ALCOHOL SOLVENTE',
      subtitle: 'Adhesivo Compuesto de Alcohol Solvente de Alto Rendimiento',
      description: 'Adhesivo compuesto de alcohol solvente profesional con excelente rendimiento de unión, ampliamente utilizado en varios materiales de empaque',
      viewMore: 'Ver Productos'
    },
    materials: {
      title: 'Nuevos Materiales de Carbono',
      subtitle: 'Tecnología Avanzada de Materiales de Carbono',
      description: 'Incluyen principalmente nanotubos de carbono y suspensión, nanofibras de carbono, múltiples materiales de ánodo a base de grafito, aglutinantes a base de agua y n-metilpirrolidona',
      viewMore: 'Aprender Más'
    },
    news: {
      title: 'Centro de Noticias',
      subtitle: 'Conoce las últimas dinámicas de la empresa',
      description: 'Obtén las últimas noticias de la empresa y dinámicas de la industria, conoce nuestro progreso más reciente en innovación tecnológica y expansión de mercado',
      viewMore: 'Ver Noticias'
    },
    support: {
      title: 'Soporte Técnico',
      subtitle: 'Documentación Técnica Profesional y Soporte',
      description: 'Proporciona hojas de datos técnicos completos, especificaciones de productos, guías de usuario y otros documentos profesionales para soporte técnico integral',
      viewMore: 'Obtener Soporte'
    },
    hr: {
      title: 'Recursos Humanos',
      subtitle: 'Únete a nosotros, creando el futuro juntos',
      description: 'Sinceramente invitamos a individuos talentosos a unirse a nuestro equipo, ofreciendo compensación competitiva y amplias oportunidades de desarrollo',
      viewMore: 'Ver Posiciones'
    },
    contact: {
      title: 'Contáctenos',
      subtitle: 'Póngase en contacto con nosotros en cualquier momento',
      description: 'Esperamos cooperar con usted, proporcionando consulta profesional y soporte de servicios a través de varios canales',
      viewMore: 'Información de Contacto'
    }
  },
  productsPage: {
    pageTitle: 'Adhesivo',
    title: 'Productos',
    meta: {
      description: 'Introducción de Productos de Huzhou OChem Chemical Co., Ltd. - Adhesivos compuestos de empaque suave, adhesivos de ingeniería estructural y otros productos químicos profesionales'
    },
    solventFree: {
      title: 'ADHESIVO LIBRE DE SOLVENTE',
      subtitle: 'ADHESIVO LIBRE DE SOLVENTE'
    },
    esterSolvent: {
      title: 'ADHESIVO A BASE DE ÉSTER SOLVENTE',
      subtitle: 'ADHESIVO A BASE DE ÉSTER SOLVENTE'
    },
    performanceLevel: 'Nivel de Rendimiento',
    icons: {
      lamination: {
        main: 'Laminación',
        sub: 'LAMINACIÓN'
      },
      boiling: {
        main: 'Ebullición 100°C/30min Transparente',
        sub: 'PASTEURIZACIÓN DE EBULLICIÓN'
      },
      retort: {
        main: 'Retorta',
        sub: 'RETORTA'
      },
      specialities: {
        main: 'Especialidades',
        sub: 'ESPECIALIDADES'
      },
      chemical: {
        main: 'Resistencia Química',
        sub: 'RESISTENCIA QUÍMICA'
      }
    },
    performance: {
      high: 'Alto Rendimiento',
      highSub: '高性能',
      medium: 'Rendimiento Medio',
      mediumSub: '中性能',
      standard: 'Rentable',
      standardSub: '普通性能'
    }
  },
  solventFreeProductsPage: {
    pageTitle: 'ADHESIVO LIBRE DE SOLVENTE',
    title: 'Adhesivo Libre de Solvente - Productos',
    meta: {
      description: 'Introducción de Productos de Huzhou OChem Chemical Co., Ltd. - Adhesivos compuestos de empaque suave, adhesivos de ingeniería estructural y otros productos químicos profesionales'
    },
    solventFree: {
      title: 'ADHESIVO LIBRE DE SOLVENTE',
      subtitle: 'Adhesivo Integral de Primera Elección para Laminación de Empaques Suaves'
    },
    performanceLevel: 'Nivel de Rendimiento',
    icons: {
      lamination: {
        main: 'Laminación',
        sub: 'LAMINACIÓN'
      },
      boiling: {
        main: 'Ebullición 100°C/30min Transparente',
        sub: 'PASTEURIZACIÓN DE EBULLICIÓN'
      },
      retort: {
        main: 'Retorta',
        sub: 'RETORTA'
      },
      specialities: {
        main: 'Especialidades',
        sub: 'ESPECIALIDADES'
      },
      chemical: {
        main: 'Resistencia Química',
        sub: 'RESISTENCIA QUÍMICA'
      }
    },
    performance: {
      high: 'Alto Rendimiento',
      highSub: '高性能',
      medium: 'Rendimiento Medio',
      mediumSub: '中性能',
      standard: 'Rentable',
      standardSub: '普通性能'
    },
    features: 'Característica'
  },
  esterSolventProductsPage: {
    pageTitle: 'ADHESIVO A BASE DE ÉSTER SOLVENTE',
    title: 'Adhesivo a Base de Éster Solvente - Productos',
    meta: {
      description: 'Introducción de Productos de Huzhou OChem Chemical Co., Ltd. - Adhesivos compuestos de empaque suave, adhesivos de ingeniería estructural y otros productos químicos profesionales'
    },
    esterSolvent: {
      title: 'ADHESIVO A BASE DE ÉSTER SOLVENTE',
      subtitle: 'Adhesivo Integral de Primera Elección para Laminación de Empaques Suaves'
    },
    performanceLevel: 'Nivel de Rendimiento',
    icons: {
      lamination: {
        main: 'Laminación',
        sub: 'LAMINACIÓN'
      },
      boiling: {
        main: 'Ebullición 100°C/30min Transparente',
        sub: 'PASTEURIZACIÓN DE EBULLICIÓN'
      },
      retort: {
        main: 'Retorta',
        sub: 'RETORTA'
      },
      specialities: {
        main: 'Especialidades',
        sub: 'ESPECIALIDADES'
      },
      chemical: {
        main: 'Resistencia Química',
        sub: 'RESISTENCIA QUÍMICA'
      }
    },
    performance: {
      high: 'Alto Rendimiento',
      highSub: '高性能',
      medium: 'Rendimiento Medio',
      mediumSub: '中性能',
      standard: 'Rentable',
      standardSub: '普通性能'
    },
    features: 'Característica'

  },
  alcoholicSolventProductsPage: {
    pageTitle: 'ADHESIVO A BASE DE DISOLVENTES ALCOHÓLICOS',
    title: 'Adhesivo a Base de Disolventes Alcohólicos - Productos',
    meta: {
      description: 'Introducción de Productos de Huzhou OChem Chemical Co., Ltd. - Adhesivos compuestos de empaque suave, adhesivos de ingeniería estructural y otros productos químicos profesionales'
    },
    alcoholicSolvent: {
      title: 'ADHESIVO A BASE DE DISOLVENTES ALCOHÓLICOS',
      subtitle: 'Adhesivo Integral de Primera Elección para Laminación de Empaques Suaves'
    },
    performanceLevel: 'Nivel de Rendimiento',
    icons: {
      lamination: {
        main: 'Laminación',
        sub: 'LAMINACIÓN'
      },
      boiling: {
        main: 'Ebullición 100°C/30min Transparente',
        sub: 'PASTEURIZACIÓN DE EBULLICIÓN'
      },
      retort: {
        main: 'Retorta',
        sub: 'RETORTA'
      },
      specialities: {
        main: 'Especialidades',
        sub: 'ESPECIALIDADES'
      },
      chemical: {
        main: 'Resistencia Química',
        sub: 'RESISTENCIA QUÍMICA'
      }
    },
    performance: {
      high: 'Alto Rendimiento',
      highSub: '高性能',
      medium: 'Rendimiento Medio',
      mediumSub: '中性能',
      standard: 'Rentable',
      standardSub: '普通性能'
    },
    features: {
      chinese: 'Características Chinas',
      english: 'Características Inglesas'
    }
  },
  companyName: "Compañía Química Ochem de Huzhou, Ltd."
}
